// Module
var code = `<div class="jumbotron-page play-report">

  <div class="jumbotron-toolbar play-report-toolbar">
    <div class="jumbotron-page-heading">
      <span class="jumbotron-title">Report</span>
      <span class="jumbotron-subtitle">What the screens played, from the play log</span>
    </div>

    <div class="play-report-controls">
      <span class="jumbotron-kind-label play-report-kind">From</span>
      <input type="date" class="form-control form-control-sm play-report-date" aria-label="From date"
        ng-model="\$ctrl.window.fromDate" ng-model-options="{ updateOn: 'change blur' }"
        ng-change="\$ctrl.windowChanged()">
      <input type="time" class="form-control form-control-sm play-report-time" aria-label="From time"
        ng-model="\$ctrl.window.fromTime" ng-model-options="{ updateOn: 'change blur' }"
        ng-change="\$ctrl.windowChanged()">

      <span class="jumbotron-kind-label play-report-kind">To</span>
      <input type="date" class="form-control form-control-sm play-report-date" aria-label="To date"
        ng-model="\$ctrl.window.toDate" ng-model-options="{ updateOn: 'change blur' }"
        ng-change="\$ctrl.windowChanged()">
      <input type="time" class="form-control form-control-sm play-report-time" aria-label="To time"
        ng-model="\$ctrl.window.toTime" ng-model-options="{ updateOn: 'change blur' }"
        ng-change="\$ctrl.windowChanged()">

      <div class="btn-group btn-group-sm" role="group" aria-label="Window presets">
        <button type="button" class="btn"
          ng-class="\$ctrl.preset === 'today' ? 'btn-primary' : 'btn-outline-secondary'"
          ng-click="\$ctrl.usePreset('today')">Today</button>
        <button type="button" class="btn"
          ng-class="\$ctrl.preset === 'yesterday' ? 'btn-primary' : 'btn-outline-secondary'"
          ng-click="\$ctrl.usePreset('yesterday')">Yesterday</button>
        <button type="button" class="btn"
          ng-class="\$ctrl.preset === 'month' ? 'btn-primary' : 'btn-outline-secondary'"
          ng-click="\$ctrl.usePreset('month')"
          title="The widest window the report reads">Last 30 days</button>
      </div>

      <select class="form-select form-select-sm play-report-scene-select" aria-label="Scene"
        ng-model="\$ctrl.sceneId" ng-change="\$ctrl.load()"
        ng-options="scene.id as scene.name for scene in \$ctrl.scenes">
        <option value="">All scenes</option>
      </select>

      <input type="search" class="form-control form-control-sm play-report-search" placeholder="Search name"
        aria-label="Search name" ng-model="\$ctrl.search" ng-change="\$ctrl.searchChanged()">

      <span class="play-report-window-problem" ng-if="\$ctrl.windowProblem" role="alert">
        <i class="fas fa-triangle-exclamation" aria-hidden="true"></i> {{ \$ctrl.windowProblem }}
      </span>

      <button type="button" class="btn btn-sm btn-outline-primary" ng-click="\$ctrl.exportCsv()"
        title="Every media of the window, one row per media, scene and day">
        <i class="fas fa-download" aria-hidden="true"></i> Export CSV
      </button>
    </div>
  </div>

  <div class="jumbotron-surface play-report-tiles">
    <div class="play-report-tile">
      <span class="jumbotron-kind-label play-report-kind">Plays</span>
      <span class="jumbotron-tile-value play-report-tile-value">{{ \$ctrl.view.tiles.plays | number }}</span>
      <span class="jumbotron-note">{{ \$ctrl.view.tiles.playsNote }}</span>
    </div>
    <div class="play-report-tile">
      <span class="jumbotron-kind-label play-report-kind">Screen time</span>
      <span class="jumbotron-tile-value play-report-tile-value">{{ \$ctrl.view.tiles.screenMs | duration }}</span>
      <span class="jumbotron-note">plays that started and ended</span>
    </div>
    <div class="play-report-tile">
      <span class="jumbotron-kind-label play-report-kind">Media</span>
      <span class="jumbotron-tile-value play-report-tile-value">{{ \$ctrl.view.tiles.mediaCount }}</span>
      <span class="jumbotron-note">names in the log</span>
    </div>
    <div class="play-report-tile">
      <span class="jumbotron-kind-label play-report-kind">Longest no contact</span>
      <span class="jumbotron-tile-value play-report-tile-value" ng-class="{ 'is-warn': \$ctrl.view.tiles.longestNoContactMs > 0 }">{{
        \$ctrl.view.tiles.noContactLabel }}</span>
      <span class="jumbotron-note">{{ \$ctrl.view.tiles.noContactNote }}</span>
    </div>
    <div class="play-report-tile">
      <span class="jumbotron-kind-label play-report-kind">Failed</span>
      <span class="jumbotron-tile-value play-report-tile-value" ng-class="{ 'is-bad': \$ctrl.view.tiles.failed > 0 }">{{
        \$ctrl.view.tiles.failed }}</span>
      <span class="jumbotron-note">plays that ended with an error</span>
    </div>
  </div>

  <div class="play-report-columns">

    <div class="jumbotron-surface play-report-main">
      <div class="jumbotron-panel-head play-report-surface-head">
        <span class="jumbotron-heading">Screen time per media</span>
        <span class="jumbotron-note">
          <i class="fas fa-circle-notch fa-spin" aria-hidden="true" ng-if="\$ctrl.loading"></i>
          Sorted by screen time. Click a row for its hours.
        </span>
      </div>

      <div class="jumbotron-scroll">
        <table class="jumbotron-table play-report-table">
          <thead>
            <tr>
              <th class="jumbotron-table-head-cell play-report-icon-cell"><span class="visually-hidden">Type</span></th>
              <th class="jumbotron-table-head-cell">Media</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Plays</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Screen time</th>
              <th class="jumbotron-table-head-cell play-report-bar-cell"><span class="visually-hidden">Share of the longest screen time</span>
              </th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num" ng-repeat="column in \$ctrl.view.sceneColumns track by column.id">
                <span class="play-report-scene-head">
                  <span class="jumbotron-dot play-report-dot" ng-style="{ 'background-color': column.colour }"></span>{{ column.name }}
                </span>
              </th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Per hour</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Failed</th>
            </tr>
          </thead>
          <tbody>
            <tr class="play-report-row" tabindex="0" ng-repeat="row in \$ctrl.view.rows track by row.key"
              ng-class="{ 'is-selected': \$ctrl.view.selected.key === row.key }"
              ng-click="\$ctrl.selectMedia(row)"
              ng-keydown="\$event.key === 'Enter' && \$ctrl.selectMedia(row)">
              <td class="jumbotron-table-cell play-report-icon-cell">
                <i class="fas" ng-class="\$ctrl.iconFor(row.type)" aria-hidden="true"></i>
              </td>
              <td class="jumbotron-table-cell play-report-media-cell">{{ row.label }}</td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">{{ row.plays | number }}</td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">{{ row.screenMs | duration }}</td>
              <td class="jumbotron-table-cell play-report-bar-cell">
                <span class="jumbotron-bar-track play-report-bar">
                  <span class="jumbotron-bar-fill play-report-bar-fill" ng-style="{ width: row.bar + '%' }"></span>
                </span>
              </td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num" ng-repeat="column in \$ctrl.view.sceneColumns track by column.id">
                <span ng-if="row.playsByScene[column.id]">{{ row.playsByScene[column.id] | number }}</span>
                <span class="jumbotron-note" ng-if="!row.playsByScene[column.id]">&ndash;</span>
              </td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">{{ row.perHour | number:1 }}</td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">
                <span class="play-report-failed" ng-if="row.failed">{{ row.failed }}</span>
                <span class="jumbotron-note" ng-if="!row.failed">&ndash;</span>
              </td>
            </tr>
          </tbody>
        </table>

        <p class="play-report-empty" ng-if="!\$ctrl.view.rows.length">No plays in this window.</p>
      </div>

      <p class="jumbotron-note play-report-foot">
        <span ng-if="!\$ctrl.search">{{ \$ctrl.view.tiles.mediaCount }} media.</span>
        <span ng-if="\$ctrl.search">{{ \$ctrl.view.rows.length }} of {{ \$ctrl.view.tiles.mediaCount }} media match the
          search.</span>
        Screen time counts plays that both started and ended. Per hour is plays per hour of the window.
      </p>
    </div>

    <div class="jumbotron-surface play-report-side" ng-if="!\$ctrl.view.selected">
      <div class="jumbotron-panel-head play-report-surface-head">
        <span class="jumbotron-heading">Findings</span>
        <span class="jumbotron-note">{{ \$ctrl.view.findings.total }} found</span>
      </div>

      <div class="jumbotron-scroll">
        <div ng-repeat="group in \$ctrl.view.findings.groups track by group.key">
          <p class="play-report-group">
            <span class="jumbotron-kind-label play-report-kind" ng-class="group.tone">{{ group.title }} &middot; {{ group.count }}</span>
            <span class="jumbotron-note" ng-if="group.note">{{ group.note }}</span>
          </p>
          <div class="play-report-finding" ng-repeat="line in group.lines track by \$index">
            <span class="jumbotron-dot-big play-report-finding-dot" ng-style="{ 'background-color': line.colour }"></span>
            <div class="play-report-finding-text">
              <strong>{{ line.title }}</strong> &middot; {{ line.detail }}
              <span class="jumbotron-note">{{ line.note }}</span>
            </div>
          </div>
        </div>

        <p class="play-report-empty" ng-if="!\$ctrl.view.findings.groups.length">Nothing to report in this window.</p>
      </div>

      <p class="jumbotron-note play-report-foot">
        No contact means the player sent no report. The screen may have played from its cache. Plays the queue dropped
        at a playlist change are not counted anywhere.
      </p>
    </div>

    <div class="jumbotron-surface play-report-side" ng-if="\$ctrl.view.selected">
      <div class="jumbotron-panel-head play-report-surface-head">
        <span class="jumbotron-heading">Media</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.closeMedia()">
          <i class="fas fa-xmark" aria-hidden="true"></i> Close
        </button>
      </div>

      <div class="jumbotron-scroll">
        <div class="play-report-media-head">
          <span class="play-report-media-name">{{ \$ctrl.view.selected.label }}</span>
          <span class="jumbotron-note">{{ \$ctrl.labelFor(\$ctrl.view.selected.type) }} &middot;
            {{ \$ctrl.view.selected.plannedMs | duration }} planned</span>
        </div>

        <div class="play-report-media-numbers">
          <div>
            <span class="jumbotron-kind-label play-report-kind">Plays</span>
            <span class="jumbotron-tile-value">{{ \$ctrl.view.selected.plays | number }}</span>
          </div>
          <div>
            <span class="jumbotron-kind-label play-report-kind">Screen time</span>
            <span class="jumbotron-tile-value">{{ \$ctrl.view.selected.screenMs | duration }}</span>
          </div>
          <div>
            <span class="jumbotron-kind-label play-report-kind">Per hour</span>
            <span class="jumbotron-tile-value">{{ \$ctrl.view.selected.perHour | number:1 }}</span>
          </div>
        </div>

        <table class="jumbotron-table play-report-mini">
          <thead>
            <tr>
              <th class="jumbotron-table-head-cell">Scene</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Plays</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Screen time</th>
              <th class="jumbotron-table-head-cell jumbotron-number-cell play-report-num">Failed</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="scene in \$ctrl.view.selected.scenes track by scene.id">
              <td class="jumbotron-table-cell">
                <span class="jumbotron-dot play-report-dot" ng-style="{ 'background-color': scene.colour }"></span>{{ scene.name }}
              </td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">
                <span ng-if="scene.plays">{{ scene.plays | number }}</span>
                <span class="jumbotron-note" ng-if="!scene.plays">&ndash;</span>
              </td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">
                <span ng-if="scene.screenMs">{{ scene.screenMs | duration }}</span>
                <span class="jumbotron-note" ng-if="!scene.screenMs">&ndash;</span>
              </td>
              <td class="jumbotron-table-cell jumbotron-number-cell play-report-num">
                <span class="play-report-failed" ng-if="scene.failed">{{ scene.failed }}</span>
                <span class="jumbotron-note" ng-if="!scene.failed">&ndash;</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="play-report-chart-head">
          <span class="jumbotron-kind-label play-report-kind">{{ \$ctrl.view.selected.chart.heading }}</span>
          <span class="play-report-legend">
            <span ng-repeat="scene in \$ctrl.view.selected.chart.legend track by scene.id">
              <span class="jumbotron-dot play-report-dot" ng-style="{ 'background-color': scene.colour }"></span>{{ scene.name }}
            </span>
          </span>
        </div>

        <div class="play-report-chart">
          <div class="play-report-chart-plot">
            <span class="play-report-chart-line is-top"></span>
            <span class="play-report-chart-line is-half"></span>
            <span class="play-report-chart-tick is-top">{{ \$ctrl.view.selected.chart.top }}</span>
            <span class="play-report-chart-tick is-half">{{ \$ctrl.view.selected.chart.half }}</span>
            <div class="play-report-chart-columns">
              <div class="play-report-chart-column"
                ng-repeat="column in \$ctrl.view.selected.chart.columns track by column.key"
                title="{{ column.key }} &middot; {{ column.total }} plays">
                <span class="play-report-chart-segment"
                  ng-repeat="segment in column.segments track by segment.id"
                  ng-style="{ height: segment.percent + '%', 'background-color': segment.colour }"></span>
              </div>
            </div>
          </div>
          <div class="play-report-chart-axis">
            <span ng-repeat="column in \$ctrl.view.selected.chart.columns track by column.key">{{ column.label }}</span>
          </div>
        </div>
      </div>

      <p class="jumbotron-note play-report-foot">
        Export CSV writes every media of the window, one row per media, scene and day.
      </p>
    </div>

  </div>
</div>
`;
// Exports
export default code;